import http from './http';

export const authApi = {
  login(payload) {
    return http.post('/auth/login', payload);
  },
  memberRegister(payload) {
    return http.post('/auth/member-register', payload);
  },
  profile() {
    return http.get('/auth/profile');
  },
  logout() {
    return http.post('/auth/logout');
  },
  updatePassword(payload) {
    return http.put('/auth/password', payload);
  }
};

export const publicApi = {
  home() {
    return http.get('/public/home');
  },
  services(params) {
    return http.get('/public/services', { params });
  },
  employees(params) {
    return http.get('/public/employees', { params });
  },
  createAppointment(payload) {
    return http.post('/public/appointments', payload);
  }
};

export const memberPortalApi = {
  overview() {
    return http.get('/member/overview');
  },
  appointments(params) {
    return http.get('/member/appointments', { params });
  },
  recharges(params) {
    return http.get('/member/recharges', { params });
  },
  consumes(params) {
    return http.get('/member/consumes', { params });
  },
  redemptions(params) {
    return http.get('/member/redemptions', { params });
  },
  mockRecharge(payload) {
    return http.post('/member/mock-recharge', payload);
  },
  redeem(payload) {
    return http.post('/member/redeem', payload);
  }
};

export const dashboardApi = {
  getSummary() {
    return http.get('/manage/dashboard');
  }
};

export const memberApi = {
  page(params) {
    return http.get('/manage/members', { params });
  },
  options() {
    return http.get('/manage/members/options');
  },
  save(payload) {
    return http.post('/manage/members', payload);
  },
  remove(id) {
    return http.delete('/manage/members', { params: { id } });
  }
};

export const serviceApi = {
  page(params) {
    return http.get('/manage/services', { params });
  },
  options() {
    return http.get('/manage/services/options');
  },
  save(payload) {
    return http.post('/manage/services', payload);
  },
  remove(id) {
    return http.delete('/manage/services', { params: { id } });
  }
};

export const employeeApi = {
  page(params) {
    return http.get('/manage/employees', { params });
  },
  options() {
    return http.get('/manage/employees/options');
  },
  save(payload) {
    return http.post('/manage/employees', payload);
  },
  remove(id) {
    return http.delete('/manage/employees', { params: { id } });
  }
};

export const appointmentApi = {
  page(params) {
    return http.get('/manage/appointments', { params });
  },
  save(payload) {
    return http.post('/manage/appointments', payload);
  },
  remove(id) {
    return http.delete('/manage/appointments', { params: { id } });
  },
  updateStatus(payload) {
    return http.post('/manage/appointments/status', payload);
  },
  checkConflict(params) {
    return http.get('/manage/appointments/conflict', { params });
  }
};

export const financeApi = {
  recharges(params) {
    return http.get('/manage/finance/recharges', { params });
  },
  createRecharge(payload) {
    return http.post('/manage/finance/recharges', payload);
  },
  consumes(params) {
    return http.get('/manage/finance/consumes', { params });
  },
  createConsume(payload) {
    return http.post('/manage/finance/consumes', payload);
  }
};

export const accountApi = {
  page(params) {
    return http.get('/manage/users', { params });
  },
  save(payload) {
    return http.post('/manage/users', payload);
  },
  remove(id) {
    return http.delete('/manage/users', { params: { id } });
  }
};
